export default "__VITE_PUBLIC_ASSET__1f8d3e9c__"